
const Heading = () => {
  return (
    <header className="container"><h2 className="center-align heading silom">Choose Your Color</h2></header>
  )
}


export default Heading